module.exports = __webpack_public_path__ + "img/示例图_5-3.4fb7789e.png";